import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
// components
import AuthHeader from '../components/Headers/AuthHeader.component';
import Footer1 from '../components/Footers/Footer1.component';
import ReactImageFallback from 'react-image-fallback';

import { IoPaperPlane } from 'react-icons/io5';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader.component';
import Receiver from '../components/ChatMessage/Receiver.component';
import Sender from '../components/ChatMessage/Sender.component';

import defaultUser from "../assets/images/default_profile_pic.jpg";

export default function UserChat() {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const post_id = urlParams?.get('post_id');
    
    // const { id } = useParams();
    const [chat, setChat] = useState('');
    const [receiverID, setReceiverID] = useState('');
    const [members, setMembers] = useState('');
    const [message, setMessage] = useState("");
    const [tmpUser, setTmpUser] = useState("");
    // redux state 
    const token = useSelector(state => state.auth.token);
    const userData = useSelector(state => state.auth.data);


        // get new user chat 
        const getNewUser = async () => {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts?post_id=${post_id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            .then(r => r.json())
            .then(response => {
                if(response.success){
                    // customer check for freelancer
                    if(userData?.role === 3){
                        setTmpUser(response.records.data[0].assign_post.user);
                        setReceiverID(response.records.data[0].assign_post.user.id);
                        getUserChat(userData?.id, response.records.data[0].assign_post.user.id);
                    }
                    // freelancer check for customer
                    if(userData?.role === 2){
                        setTmpUser(response.records.data[0].customer);
                        setReceiverID(response.records.data[0].customer.id);
                        getUserChat(response.records.data[0].customer.id);
                    }
                }
            })
        };
    
        useEffect(() => {
            if(post_id){
                getNewUser();
            }
        }, []);

 
    // utility functions
    // getting all the memebers 
    const getAllMembers = async () => {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/chats?sender_id=${userData?.id}&last_chat_all=true`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
        .then(r => r.json())
        .then(response => {
            if (response.success) {
                setMembers(response.records.data);
            }
        })
    };
    // get all members on page load 
    useEffect(() => {
        getAllMembers();
    }, []);


    // get selected user chat 
    const getUserChat = async (sender_id, receiver_id) => {
        // console.log(receiver_id);
        if (receiver_id) {
            await fetch(`${process.env.REACT_APP_BASE_URL}/api/chats?sender_id=${sender_id}&receiver_id=${receiver_id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            .then(r => r.json())
            .then(response => {
                if (response.success) {
                    let data = response.records.data.sort((a, b) => {
                        const aDate = new Date(a.updated_at);
                        const bDate = new Date(b.updated_at);
                        if (aDate > bDate) { return 1; }
                        if (aDate < bDate) { return -1; }
                        return 0;
                    });
                    setChat(response.records.data);
                }
            })
        } else {
            setChat("");
        }
    };
    // ***********************  RE-LOAD MESSAGES
    useEffect(() => {
        let interval = "";
        if (receiverID) {
            interval = setInterval(() => {
                getUserChat(userData?.id, receiverID);
            }, 10000);
        }
        return () => clearInterval(interval);
    }, [chat, receiverID]);
    // useEffect(() => {}, [chat]);



    // *************************** MESSAGE SEND 
    // input handler
    const handleChangeMessage = (e) => {
        let val = e.target.value;
        setMessage(val);
    }
    // sending message 
    const sendMsg = useCallback(async (e) => {
        e.preventDefault();
        if (receiverID) {
            setMessage("");
            const sendMsgData = new FormData();
            sendMsgData.append("sender_id", userData?.id);
            sendMsgData.append("receiver_id", receiverID);
            sendMsgData.append("text", message);

            // console.log("UserData id", parseInt(userData.id))
            // // console.log("Receiver id", parseInt(id));
            // console.log("message", message);

            await fetch(`${process.env.REACT_APP_BASE_URL}/api/chats`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: sendMsgData
            })
                .then(r => r.json())
                .then(response => {
                    if (response.success) {
                        // console.log(response);
                        let newmsg = response.records;
                        setChat([...chat, newmsg]);
                    }
                })
        }
    });

    return (
        <>
            <AuthHeader />

            {/* chat section starts */}
            {
                // !chat ? <Loader /> : 
                <section className='my-5 userChat_container h-100'>
                    <div className="container-lg">
                        <div className="row align-items-stretched">

                            {/* users list start !!! */}

                            <div className="col-md-4 col-lg-5 col-xl-4 mb-4 mb-md-0">
                                <div className="bds-box p-0 overflow-hidden">
                                    <div className="p-0 userChat_users_container h-100">
                                        <div className="card-body">
                                            <h5 className="py-3 px-3">All Users</h5>
                                            <ul className="list-unstyled mb-0">
                                                {
                                                    post_id && tmpUser.id !== userData.id  ? 
                                                         <li className={`p-2 userChat_member active_userChat`}>
                                                        <Link
                                                            to="#"                                                                
                                                            className="d-flex justify-content-between align-items-center"
                                                        >
                                                            <div className="d-flex flex-row">
                                                                <ReactImageFallback
                                                                    src={`${process.env.REACT_APP_BASE_URL}/public/storage/${tmpUser.profile_image}`}
                                                                    initialImage={defaultUser}
                                                                    fallbackImage={defaultUser}
                                                                    alt="avatar"
                                                                    className="rounded-circle d-flex align-self-center me-3 shadow-1-strong"
                                                                    width="60"
                                                                />
                                                                <div className="pt-1">
                                                                    <p className="fw-bold mb-0">
                                                                        {tmpUser.first_name != null && tmpUser.last_name != null ? tmpUser.first_name + " " + tmpUser.last_name : tmpUser.name}
                                                                    </p>                                                                       
                                                                </div>
                                                            </div>
                                                            {/* <div className="pt-1">
                                                                <span className="badge bg-danger float-end rounded-circle">1</span>
                                                            </div> */}
                                                        </Link>
                                                    </li> 
                                                    : ""                                                
                                                }
                                                
                                                {
                                                    members && members.map((item, idx) =>{
                                                        if(item?.receiver_id !== userData?.id ) {
                                                           return  <li className={`p-2 userChat_member ${receiverID === item?.receiver_id ? "active_userChat" : ""}`} key={idx}>
                                                                <Link
                                                                    to=""
                                                                    onClick={() => { setReceiverID(item?.receiver_id); getUserChat(item?.sender_id, item?.receiver_id); }}
                                                                    className="d-flex justify-content-between align-items-center"
                                                                >
                                                                    <div className="d-flex flex-row">
                                                                        <ReactImageFallback
                                                                            src={`${process.env.REACT_APP_BASE_URL}/public/storage/${item?.receiver_details?.profile_image}`}
                                                                            initialImage={defaultUser}
                                                                            fallbackImage={defaultUser}
                                                                            alt="avatar"
                                                                            className="rounded-circle d-flex align-self-center me-3 shadow-1-strong"
                                                                            width="60"
                                                                        />
                                                                        <div className="pt-1">
                                                                            <p className="fw-bold mb-0">
                                                                                {item?.receiver_details?.first_name != null && item?.receiver_details?.last_name != null ? item?.receiver_details?.first_name + " " + item?.receiver_details?.last_name : item?.receiver_details?.name}
                                                                            </p>
                                                                            <p className="small text-muted mb-0">{
                                                                                item?.text}</p>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="pt-1">
                                                                        <span className="badge bg-danger float-end rounded-circle">1</span>
                                                                    </div> */}
                                                                </Link>
                                                            </li>
                                                        } else {
                                                               return  <li className={`p-2 userChat_member ${receiverID === item?.sender_id ? "active_userChat" : ""}`} key={idx}>
                                                                    <Link
                                                                        to=""
                                                                        onClick={() => { setReceiverID(item?.sender_id); getUserChat(item?.sender_id, item?.receiver_id); }}
                                                                        className="d-flex justify-content-between align-items-center"
                                                                    >
                                                                        <div className="d-flex flex-row">
                                                                            <ReactImageFallback
                                                                                src={`${process.env.REACT_APP_BASE_URL}/public/storage/${item?.sender_details?.profile_image}`}
                                                                                initialImage={defaultUser}
                                                                                fallbackImage={defaultUser}
                                                                                alt="avatar"
                                                                                className="rounded-circle d-flex align-self-center me-3 shadow-1-strong"
                                                                                width="60"
                                                                            />
                                                                            <div className="pt-1">
                                                                                <p className="fw-bold mb-0">
                                                                                    {item?.sender_details?.first_name != null && item?.sender_details?.last_name != null ? item?.sender_details?.first_name + " " + item?.sender_details?.last_name : item?.sender_details?.name}
                                                                                </p>
                                                                                <p className="small text-muted mb-0">{
                                                                                    item?.text}</p>
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className="pt-1">
                                                                            <span className="badge bg-danger float-end rounded-circle">1</span>
                                                                        </div> */}
                                                                    </Link>
                                                                </li>                                                            
                                                        }
                                                    })
                                                }

                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* users list ends */}


                            {/* messages container starts */}
                            <div className="col-md-8 col-lg-7 mx-auto">
                                <section className="bds-box bg-gray py-0 px-0 overflow-hidden">

                                    {/* user detail starts */}
                                    {/* {
                                        receiverDetail && 
                                        <div className="bg-white p-lg-5">
                                                <ReactImageFallback
                                                    src={`${process.env.REACT_APP_BASE_URL}/public/storage/${receiverDetail?.profile_image}`}
                                                    initialImage={defaultUser}
                                                    fallbackImage={defaultUser}
                                                    alt="avatar"
                                                    className="rounded-circle d-flex align-self-start me-3 shadow-1-strong"
                                                    width="80"
                                                />
                                        </div>
                                    } */}
                                    {/* user detail ends */}

                                    <ul className="userChat_messages_container px-lg-5 px-3 pt-3">
                                        {
                                            chat && chat.map((item, idx) =>
                                                item?.sender_id === userData?.id ?
                                                    <Sender
                                                        key={idx}
                                                        chat={item}
                                                        senderDetail={{
                                                            profile_image: item.sender_details.profile_image
                                                        }}
                                                    />
                                                    :
                                                    <Receiver
                                                        key={idx}
                                                        chat={item}
                                                        receiverDetail={{
                                                            profile_image: item.receiver_details.profile_image
                                                        }}
                                                    />
                                            )
                                        }
                                    </ul>

                                    {/* Send Message Control Starts */}
                                    <form onSubmit={(e) => sendMsg(e)}>
                                        <div className="userChat_input_container">
                                            <div className="userChat_input_wrapper">
                                                <input
                                                    type="text"
                                                    className="bds-themeinput"
                                                    placeholder="Say Something..."
                                                    value={message}
                                                    onChange={e => handleChangeMessage(e)}
                                                />
                                                <button className="btn userCaht_sendMsgBtn" type="submit"><IoPaperPlane /></button>
                                            </div>
                                        </div>
                                    </form>
                                    {/* Send Message Control ends */}

                                </section>
                            </div>
                            {/* messages container ends */}

                        </div>
                    </div>
                </section>
            }

            {/* chat section ends */}

            <Footer1 />
        </>
    )
}
